import { twMerge } from 'tailwind-merge';

import { Typography } from '@/shared/ui';
import { Soon } from '@/shared/ui/components/soon';

import { IPaymentMethodInfo } from '../model/types';

interface NativePaymentMethodItem {
  onClick?: () => void;
  method: IPaymentMethodInfo;
}
export const NativePaymentMethodItem = ({
  onClick,
  method,
}: NativePaymentMethodItem) => {
  return (
    <div
      className={twMerge([
        'flex items-center gap-x-4 py-2',
        !method.isSoon && 'cursor-pointer',
      ])}
      onClick={!method.isSoon ? onClick : undefined}
    >
      {method.icon}
      <div className="flex w-full flex-col gap-y-1">
        <div className="flex w-full items-center justify-between">
          <Typography>{method.title}</Typography>
          {method.isSoon && <Soon />}
        </div>

        <Typography variant="14-r" color="base-300">
          {method.description}
        </Typography>
      </div>
    </div>
  );
};
